import Service from '@/helpers/service'

export default {

    get(page, params) {
        return Service().get('SourceType?page=' + page, {params});
    }, 
    show(id) {
        return Service().get('SourceType/show/'+id);
    },    
    create(params) {
        return Service().post('SourceType/create', params);
    },
    update(id, params) {
        return Service().post('SourceType/update/'+id, params);
    },
    delete(id) {
        return Service().post('SourceType/delete/'+id);
    }
}